import axios from 'axios';
import qs from 'qs';

const codeMessage = {
    200: '服务器成功返回请求的数据。',
    201: '新建或修改数据成功。',
    202: '一个请求已经进入后台排队（异步任务）。',
    204: '删除数据成功。',
    400: '发出的请求有错误，服务器没有进行新建或修改数据的操作。',
    401: '用户没有权限（令牌、用户名、密码错误）。',
    403: '用户得到授权，但是访问是被禁止的。',
    404: '发出的请求针对的是不存在的记录，服务器没有进行操作。',
    406: '请求的格式不可得。',
    410: '请求的资源被永久删除，且不会再得到的。',
    422: '当创建一个对象时，发生a一个验证错误。',
    500: '服务器发生错误，请检查服务器。',
    502: '网关错误。',
    503: '服务不可用，服务器暂时过载或维护。',
    504: '网关超时。',
};

/**
 * 请求类
 */
export class BaseApi {
    servers;

    /**
     * 初始化servers
     */
    constructor(hot) {
        /**
         * 初始化servers
         */
        this.servers = axios.create({
            baseURL: hot,
            timeout: 600000,
            withCredentials: true,
        });
        this.servers.interceptors.request.use(
            config => {
                if (config.data instanceof window.FormData) {
                    config.headers = {...config.headers, 'Content-Type': 'multipart/form-data'};
                }
                return config;
            },
            error => Promise.reject(error)
        );
        this.servers.interceptors.response.use(
            response => response,
            ({response}) => {
                let errorText = response ? codeMessage[response.status] : '网络繁忙，请稍候再试！';
                if (response && response.data && response.data instanceof Object) {
                    const {message} = response.data;
                    errorText = message instanceof Array ? message[0].message : message || '请求参数错误！';
                }
                return Promise.reject(errorText);
            }
        );
    }

    /**
     * fetch
     * @param method
     * @param url
     * @param body
     * body 为form-data类型，则自动修改传输协议为multipart/form-data类型
     * @param headers
     * @returns {Promise<any>}
     */
    connection(method = 'get', url, body, headers) {
        if (typeof body !== 'object') body = {};
        method = method.toLocaleLowerCase();
        this.deleteEmptyOption(body);
        if (method === 'get') {
            url += `${url.indexOf('?') >= 0 ? '&' : '?'}${qs.stringify(body)}`;
            body = {};
        }
        return new Promise(async (resolve, reject) => {
            try {
                const result = await this.servers.request({method, url, data: body, headers});
                resolve(result.data);
            } catch (e) {
                // 这里弹出错误消息不做统一处理
                reject(e.toString());
            }
        });
    }

    deleteEmptyOption(obj, name = '') {
        if (!(obj instanceof Object)) {
            throw new Error('请传入 Object');
        }
        Object.keys(obj).forEach(key => {
            if (obj[key] instanceof Array) {
                obj[key] = obj[key].filter(v => {
                    return !(v === null || v === undefined);
                });
                obj[key].forEach((k, index) => {
                    if (typeof k === 'object') {
                        this.deleteEmptyOption(k, `${name}${key}[${index}]`);
                    }
                });
            }
            if (obj[key] === undefined || obj[key] === null || obj[key] === '') {
                delete obj[`${name}${key}`];
            }
        });
    }
}

const request = new BaseApi(process.env.BASE_API || 'https://acupoint.cn-su.net/api/');
export default request;
